import i18n from '../../i18n'

export const standards = [
    {
        key: 0,
        data: {
            // 一寸
            label: i18n.t("tools.idPhotoEditor.standards.1"),
            unit:'mm',
            width: 25,
            height: 35
        }
    },
    {
        key: 1,
        data: {
            // 二寸
            label: i18n.t("tools.idPhotoEditor.standards.2"),
            unit:'mm',
            width: 35,
            height: 50
        }
    }
];